import { head, get } from 'lodash';

export const SET_IS_AUTHORISATION_EDIT = 'SET_IS_AUTHORISATION_EDIT';
export const SET_EDIT_MODE = 'SET_EDIT_MODE';
export const SET_MULTI_TRANSACTIONS = 'SET_MULTI_TRANSACTIONS';

export const setIsAuthorisationEdit = (isAuthorisationEdit) => ({
	type: SET_IS_AUTHORISATION_EDIT,
	isAuthorisationEdit,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const setMultiTransactions = (multiTransactions) => ({
	type: SET_MULTI_TRANSACTIONS,
	multiTransactions,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const setEditMode = (payments) => {
	const action = (editMode) => ({
		type: SET_EDIT_MODE,
		editMode,
		meta: {
			allowedDuringApiCall: true,
		},
	});

	if (payments.length > 1) {
		return action('batch');
	}

	if (get(head(payments), 'type') === 'repeating') {
		return action('repeating');
	}

	return action('single');
};
